/**
 * Copy helpers for geographic names in user-visible/SEO text.
 *
 * Duplicated in scripts/prerender.mjs (build-time static pages can't import
 * TS) — keep the two in sync.
 */

// UK place names whose common usage takes the definite article ("the Lake
// District", "the Yorkshire Dales") — matched on the final word. Names not
// matching read naturally bare ("Snowdonia", "Dartmoor").
const THE_SUFFIX_RE =
  /\b(district|dales|moors|downs|wolds|fells|beacons|cairngorms|highlands|pennines|cotswolds|chilterns|mendips|trossachs|cheviots|borders|broads|marches)$/i;

export function withArticle(name: string): string {
  return THE_SUFFIX_RE.test(name.trim()) ? `the ${name}` : name;
}

/** "in <place>" phrasing for peaks/landmarks/trails; falls back to "the UK". */
export function placeOf(region: string | null | undefined, country: string | null | undefined): string {
  const raw = region || country;
  return raw ? withArticle(raw) : "the UK";
}

export function plural(n: number, word: string, pluralWord?: string): string {
  return n === 1 ? word : (pluralWord ?? `${word}s`);
}
